import { useCallback } from 'react';
import { Alert } from 'react-native';

import { ModalManager } from '../Components/Web/Modal/hooks/useModalManager';
import { MODALPROMPT } from '../Components/Web/Modal/ModalPrompt/config';
import constants from '../Config/constants';

export const getConfirmOptions = ({
  isConfirmDanger = true,
  cancelText = 'Cancel',
  okText = 'Ok',
  onCancel = () => {},
  onConfirm = () => {},
}) => {
  return {
    mobile: [
      {
        type: 'cancel',
        text: cancelText,
        onPress: onCancel,
      },
      {
        style: isConfirmDanger ? 'destructive' : 'default',
        text: okText,
        onPress: onConfirm,
      },
    ],
    web: {
      buttons: [
        {
          status: 'basic',
          text: cancelText,
          onPress: onCancel,
        },
        {
          status: isConfirmDanger ? 'danger' : 'success',
          text: okText,
          onPress: onConfirm,
        },
      ],
    },
  };
};

/**
 * Show an alert/prompt
 * @returns {(title: any, message: any, options?: { mobile?: any[]; web?: {}; }) => void}
 */
function useAlert() {
  return useCallback(
    (title, message, options = { mobile: undefined, web: {} }) => {
      if (constants.isWeb) {
        // if wan't to change the alert on web, update this.
        // BUT make sure to not change how it was use
        ModalManager.show(MODALPROMPT.prompt, {
          payload: {
            buttonStatus: 'success',
            buttonText: 'Ok',
            message,
            title,
            ...(options?.web || {}),
          },
        });
      } else {
        Alert.alert(title, message, options?.mobile);
      }
    },
    [],
  );
}

export default useAlert;
